import type {LoadRouteActionTypes, Point, RouteType} from '../model'
import {isRoutePoints} from './is-route-points'

export const loadRoute = <TError>(points: Point[], {onBoundsChange, onError}: LoadRouteActionTypes<TError>) =>
  new Promise<RouteType | null>((resolve, reject) => {
    const isRouteAvailable = isRoutePoints(points)
    if (isRouteAvailable) {
      ymaps3
        // TODO выпилить когда карты завезут свою реализацию CARGODEV-23652
        // @ts-expect-error маршруты находятся в разработке у карт, типов для них еще нет
        .route({type: 'driving', points, jams: true, bounds: true})
        // @ts-expect-error маршруты находятся в разработке у карт, типов для них еще нет
        .then((routes: {toRoute: () => RouteType}[]) => {
          const route = routes[0]?.toRoute?.()
          if (!route) {
            throw new Error('Route not found')
          }
          if (onBoundsChange && route.properties.bounds) {
            onBoundsChange({bounds: route.properties.bounds, duration: 300})
          }
          resolve(route)
        })
        .catch(error => {
          onError?.(error)
          reject(error)
        })
    } else {
      resolve(null)
    }
  })
